export const APP_VERSION = '3.9';
export const APP_NAME = 'Nano Banana Engine';
